import React from 'react';
import Appoinment from '../../../Pages/Home/Appoinment/Appoinment';
import Banner from '../Banner/Banner';
import ContactUs from '../ContactUs/ContactUs';

const Contact = () => {
    return (
        <>
            <Banner />
            <ContactUs />
            <Appoinment />   
        </>
    );
};

export default Contact;